import React from 'react';
import { FaUpload } from 'react-icons/fa'; // using react-icons for the upload icon
import styles from './index.module.css';

const UploadStatus = ({ current, total }) => (
    <div className={styles.uploadContainer}>
      <span className={styles.text}>
        Uploading Files
{' '}
{current}
{' '}
of
{' '}
{total}
      </span>
      <FaUpload className={styles.icon} />
    </div>
  );

export default UploadStatus;
